import axios from "axios";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { Dashboard_Client_Report } from "../../Configuration/API_URL";
import Header from "../../Components/Header";
import { Client_Search } from "../../Configuration/API_URL";
import ReportTableHeader from "../../Components/ReportTables/ReportTableHeader";
import Loader from "../../Components/Common/Loader";
import {
  AESEncryption,
  ApiResDecrypt,
  compareDate,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import { Constants, DP_TYPE_OPTIONS } from "../../CommonMethhods/Constants";
import "react-toastify/dist/ReactToastify.css";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import { toast } from "react-toastify";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import { useDebounce } from "../../Components/useDebounce";
import PledgeMasterTable from "../../Components/ReportTables/PledgeMasterTable";

function PledgeMasterReportSidebar() {
  const storeToken = localStorage.getItem("ssoToken");
  const [onDate, setOnDate] = useState("");
  const [clientList, setClientList] = useState([]);
  const [clientCode, setClientCode] = useState("");
  const [page, setPage] = useState(1);
  const [count, setCount] = useState();
  const [show, setShow] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [mainLoader, setMainLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [errorGrid, setErrorGrid] = useState(false);
  const [dateErrorResp, setDateErrorResp] = useState(false);
  const [clientCodeError, setClientCodeError] = useState(false);
  const [blankInputError, setBlankInputError] = useState(false);
  const [depository, setDepository] = useState("cdsl");

  const debouncedValue = useDebounce(clientCode, 1000);
  useEffect(() => {
    handleClientName(debouncedValue);
  }, [debouncedValue]);

  if (onDate === "") {
    const current = new Date();
    const date = `${
      current.getMonth() + 1
    }-${current.getDate()}-${current.getFullYear()}`;
    const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");

    setOnDate(date1);
  }

  async function searchApiDetail(code, NoPage) {
    let payloadValue = {
      keyword: code,
      Status: "",
      PageNo: NoPage,
      PageSize: 10,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getSearchDetail = await axios.post(
        Client_Search.Search_URL,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );

      const res = ApiResDecrypt(getSearchDetail?.data);
      console.log(res?.message, "status");
      if (res?.status === 0) {
        setCount(res?.data?.TotalCount);
        setClientCodeError(false);
        if (page > 1) {
          setClientList((prev) => {
            return [...prev, ...res?.data?.clients];
          });
        } else {
          setClientList(res?.data?.clients);
        }
      } else {
        setClientCodeError(res?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setScrollLoader(false);
      setBlankInputError(false);
    }
  }

  function handleClientName(data) {
    if (data) {
      searchApiDetail(data, 1);
      setScrollLoader(true);
      setClientList([]);
      setPage(1);
    }
  }

  useEffect(() => {
    if (page > 1) {
      searchApiDetail(clientCode, page);
    }
  }, [page]);
  //search api end

  const getPledgeMaster = async (fileType = "grid") => {
    if (fileType === "grid") {
      setMainLoader(true);
    }
    if (fileType === "excel") {
      setSmallLoaderExcel(true);
    }
    if (fileType === "pdf") {
      setSmallLoaderPdf(true);
    }
    let payloadValue = {
      clientCode: clientCode,
      date: onDate,
      fileType: fileType,
      dpType: depository
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axios.post(
        Dashboard_Client_Report.PledgeMasterReport_URL,
        `"${encPayload}"`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getDetails?.data);
      if (res?.status === 0) {
        if (fileType === "grid") {
          setGridData(res?.data?.pldList);
        } else if (fileType === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        } else if (fileType === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        }
      } else {
        setGridData([]);
        if (fileType !== "grid") {
          toast.error(res?.message);
        } else {
          setErrorGrid(res?.message);
        }
      }
    } catch (error) {
      console.log(error);

      if (fileType !== "grid") {
        toast.error(error?.message);
      } else {
        setErrorGrid(error?.message);
      }
    } finally {
      setMainLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
    }
  };
  const handleOnDateChange = (e) => {
    setGridData([]);
    setErrorGrid(false);
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setOnDate(d);
    setDateErrorResp(false);
  };

  const handleDepositoryChange = e => {
    setDepository(e.target.value);
    setGridData([]);
    setErrorGrid(false);
  }

  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }
  const handleOnClick = (e) => {
    if (clientCode.length > 0) {
      if (e.target.value) {
        if (compareDate(onDate)) {
          getPledgeMaster(e.target.value);
          setErrorGrid(false);
        } else {
          setDateErrorResp("Please Select Correct Date");
        }
      }
    } else {
      setBlankInputError("Please Enter Client Name/Code");
    }
  };

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  const handleScroll = async (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
      if (!(count <= 10 * page)) {
        setPage((prev) => prev + 1);
        setScrollLoader(true);
      }
    }
  };

  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="reports">
        <div className="card-box">
          <div>
            <h2 className="report-title">Pledge Master Report</h2>
          </div>
          <div className="row input-field-wrapper">
            <div className="col-md-4 col-sm-4 col-12">
              <div>
                <div className="form-group">
                  <label className="form-label">
                    {Constants.Client_Search}
                  </label>
                  <div className="rm-custom-dropdown">
                    <input
                      type="text"
                      name="search-text"
                      className="input-st"
                      placeholder="Search here..."
                      autoComplete="off"
                      value={clientCode}
                      onChange={(e) => {
                        setClientCode(e.target.value.toUpperCase());
                        setShow(true);
                        setBlankInputError(false);
                        setErrorGrid(false);
                      }}
                      onInput={(e) => {
                      const start = e.target.selectionStart;
                      const end = e.target.selectionEnd;
                      let input = e.target.value;
                      input = input
                          .toUpperCase()
                          .replace(/[^A-Z0-9\s]/g, "")
                          .replace(/\s+/g, " ")
                          .trimStart()
                          .slice(0, 100);

                      e.target.value = input;
                      e.target.setSelectionRange(start, end);
                  }}
                    />
                    <button
                      className="rm-dropdown-btn"
                      onClick={() => setShow(!show)}
                    >
                      <span className="icon-right-arrow-triangle"></span>
                    </button>
                    {show && (
                      <>
                        <ul
                          className="rm-mapping-ap border-0"
                          onScroll={(e) => handleScroll(e)}
                        >
                          {clientList &&
                            clientList.map((item, i) => (
                              <li
                                key={i}
                                className="rm-maping-item-wrapper"
                                onClick={() => {
                                  setClientCode(item?.clientCode);
                                  setShow(false);
                                }}
                              >
                                <div> {item?.clientname}</div>
                                <div> {item?.clientCode}</div>
                              </li>
                            ))}
                          {scrollLoader && !mainLoader && (
                            <div className="loader-center">
                              <LoaderForSearch />
                            </div>
                          )}
                          {clientCodeError && !scrollLoader && (
                            <li
                              className="rm-maping-item-wrapper"
                              style={{
                                borderBottom: "none",
                                fontSize: "12px",
                              }}
                            >
                              {clientCodeError}
                            </li>
                          )}
                        </ul>
                      </>
                    )}
                  </div>
                  {blankInputError && (
                    <span className="to-date-error">{blankInputError}</span>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-4 col-sm-4 col-6">
              <div className="form-group calendar-icon">
                <label className="form-label">{Constants.As_On_Date}:</label>
                <input
                  type="date"
                  placeholder="DD/MM/YYYY"
                  // className="datepicker"
                  max={DateReverse}
                  defaultValue={formatDate(onDate)}
                  className="OnDate form-control"
                  onChange={handleOnDateChange}
                />
                <span className="to-date-error">{dateErrorResp}</span>
                <span className="icon-calendar ico"></span>
              </div>
            </div>

            <div className="col-md-4 col-sm-3 col-6">
              <div className="form-group">
                <label className="form-label">DP Type:</label>
                <select style={{ padding: "5px" }} onChange={handleDepositoryChange}>
                  {DP_TYPE_OPTIONS.map((opt) => {
                    return (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          </div>

          {/* <div>
            <ClientHoldingTable />
          </div> */}
          <div className="text-center search-btn-wrapper">
            <button
              value="grid"
              className="send-message"
              onClick={handleOnClick}
            >
              {Constants.Search}
            </button>
          </div>

          <div>
            <ReportTableHeader
              showEmailBtn={false}
              smallLoaderExcel={smallLoaderExcel}
              smallLoaderPdf={smallLoaderPdf}
              handleOnClick={handleOnClick}
            />
          </div>
          <div className="for-grid-section">
            {mainLoader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : (
              gridData.length > 0 && (
                <div>
                  <PledgeMasterTable gridData={gridData} />
                </div>
              )
            )}
            {errorGrid && (
              <h4 className="report-error-message">{noDataFound(errorGrid)}</h4>
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default PledgeMasterReportSidebar;
